import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { bootWebsiteTheme } from './web-test/website-theme'
import { bootPwa } from './pwa/registerPwa'
import './styles/tokens.css'
import './styles/themes.css'
import './styles/base.css'
import './styles/layout.css'
import './styles/components.css'
import './styles/home.css'
import './styles/client.css'
import './styles/client-premium.css'
import './styles/client-broker.css'
import './styles/panels.css'
import './shared/brand-logo.css'

// One-time: end always-on Admin/IB localStorage sessions from older builds.
// New sign-ins use sessionStorage unless "Keep me signed in" is checked.
try {
  const flag = 'pp_ops_session_migration_v1'
  if (!localStorage.getItem(flag)) {
    localStorage.removeItem('pp_admin_token')
    localStorage.removeItem('pp_admin_user')
    localStorage.removeItem('pp_ib_token')
    localStorage.removeItem('pp_ib_user')
    localStorage.setItem(flag, '1')
  }
} catch {
  /* ignore */
}

if (import.meta.env.VITE_PUBLIC_WEBSITE === '1') {
  bootWebsiteTheme()
}

bootPwa()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
